// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import styles from './period_slider.module.less';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';

interface i_switch_buttons_props {
    text: string;
    id: string;
    on_click: (id: string)=>void;
    is_active: boolean;
    proxy_type: Proxy_type;
}

const Switch_buttons = (props: i_switch_buttons_props)=>{
  const {text, id, on_click, is_active, proxy_type} = props;
  const {theme} = useContext(Settings_context);
  return <div
    className={cn(
      styles.text_option,
      is_active && styles.active,
      styles[proxy_type]
    )}
    onClick={()=>on_click(id)}>
    <span className={cn(theme.p12, is_active ? theme.med : theme.reg)}>
      {text}
    </span>
  </div>;
};

interface i_period_slider_props {
    proxy_type?: Proxy_type;
}

export const Period_slider = ({proxy_type = Proxy_type.SDC}:
    i_period_slider_props)=>{
    const {qs, set_qs} = use_qs_with_set();
    const [selected_period, set_selected_period] = useState(qs.period || '1w');
    const type_class = proxy_type || Proxy_type.SDC;
    useEffect(()=>{
      set_selected_period(qs.period || '1w');
    }, [qs.period]);
    const handle_click = (id: string)=>{
        const period = id == 'weekly' ? undefined : '1m';
        set_selected_period(period || '1w');
        set_qs({period});
    };
    return <div className={cn(styles.slider_container, styles[proxy_type])}>
      <Switch_buttons
        text="Weekly"
        id="weekly"
        is_active={selected_period == '1w'}
        on_click={handle_click}
        proxy_type={type_class}
      />
      <Switch_buttons
        text="Monthly"
        id="monthly"
        is_active={selected_period == '1m'}
        on_click={handle_click}
        proxy_type={type_class}
      />
    </div>;
};
